export var PaymentTermValues = [
    'reserved',
    'exported',
    'imported',
    'delivered',
];
export var TypicaHandlingRateByBagCountTypes = [
    'less_than_5_bags',
    'more_than_5_bags',
    'more_than_10_bags',
    'more_than_50_bags',
];
export var TypicaHandlingRateByWeightTypes = [
    'less_than_300kg',
    'more_than_300kg',
    'more_than_600kg',
    'more_than_3000kg',
];
export var paymentTimingHandlingRatesOld = [
    'one_time_upfront_rate',
    'one_time_specified_date_rate',
    'one_time_after_first_delivery_rate',
    'after_each_delivery_rate',
    'one_time_after_imported_rate',
    'lump_sum_payment_after_import_rate',
    'two_times_after_imported_rate',
    'three_times_after_imported_rate',
    'four_times_after_imported_rate',
    'five_times_after_imported_rate',
];
export var paymentTimingHandlingRatesByBagAmount = [
    'one_time_upfront_rate_by_bag_amount',
    'one_time_specified_date_rate',
    'one_time_after_first_delivery_rate',
    'after_each_delivery_rate',
    'one_time_after_imported_rate',
    'lump_sum_payment_after_import_rate',
    'two_times_after_imported_rate',
    'three_times_after_imported_rate',
    'four_times_after_imported_rate',
    'five_times_after_imported_rate',
];
export var paymentTimingHandlingRatesByWeight = [
    'one_time_upfront_rate_by_weight',
    'one_time_specified_date_rate',
    'one_time_after_first_delivery_rate',
    'after_each_delivery_rate',
    'one_time_after_imported_rate',
    'lump_sum_payment_after_import_rate',
    'two_times_after_imported_rate',
    'three_times_after_imported_rate',
    'four_times_after_imported_rate',
    'five_times_after_imported_rate',
];
